import './politikerSettings.less';
import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { addCalendarDays } from '../misc/DateCalculator';
import { wageModelGroups } from '../objects/WageType';
import { PolitikerSettings } from '../objects/PolitikerSettings';

class SettingInfo {
    /**
     * 
     * @param {PolitikerSettings} settings
     * @param {SettingInfo} next
     */
    constructor(settings, next) {
        if (settings) {
            this.id = settings.Id;
            this.settings = settings;
            this.next = next;
            this.previous = null;

            if (next) {
                this.ends = addCalendarDays(next.settings.StartDate, -1);
                next.previous = this;
            }
        }
    }
}

angular.module("tromanWeb").controller('PolitikerSettingsController', ['$q', 'tromanServer', 'stateService', 'dialogService', function ($q, tromanServer, stateService, dialogService) {

    this._isSaving = false;

    this.$onInit = function () {
        $q.all({
            systemSettings: tromanServer.System.getSettings(),
            settings: tromanServer.Politiker.getSettings(),
            wageTypes: tromanServer.WageTypes.list(),
        }).then(data => {
            this.systemSettings = data.systemSettings;
            this.allWageTypes = data.wageTypes;
            this.travelWageTypes = _.filter(data.wageTypes, x => x.WageModelGroup === wageModelGroups.travel);
            this.lostIncomeWageTypes = _.filter(data.wageTypes, x => x.WageModelGroup === wageModelGroups.lostIncome);
            this.otherWageTypes = _.filter(data.wageTypes, x => x.WageModelGroup === wageModelGroups.other);

            const sorted = _.orderBy(data.settings, [x => x.StartDate], ['desc']);
            this.settings = _.reduce(sorted, (a, x) => { let m = new SettingInfo(x, a.length > 0 ? a[a.length - 1] : null); a.push(m); return a; }, []);
            this.selected = _.first(this.settings);
            this.onSelectedChanged();
        }).catch(err => {
            this.settings = null;
            this.selected = null;
            this.editing = null;
            this.allWageTypes = null;
            this.travelWageTypes = null;
            this.lostIncomeWageTypes = null;
            this.otherWageTypes = null;
            dialogService.error(err);
        });
    };

    this.canChangePeriod = function () {
        return !this.isAdding() && this.form && !this.form.$dirty;
    };

    this.onSelectedChanged = function () {
        if (this.selected) {
            this.editing = this.selected.settings.clone();
            this.maxdate = this.selected.ends;
            this.mindate = addCalendarDays(this.selected.previous?.settings.StartDate, 1);
        } else {
            this.editing = null;
            this.mindate = null;
            this.maxdate = null;
        }
    };

    this.isAdding = function () {
        return !!(this.editing && !this.editing.Id);
    };

    this.canAddPeriod = function () {
        if (this.isAdding()) return false;
        if (!this.settings) return false;
        if (!this.editing) return true;
        return this.form && !this.form.$dirty;
    };

    this.addPeriod = function () {
        if (!this.canAddPeriod()) return;

        if (this.settings.length > 0) {
            this.maxdate = null;
            this.mindate = addCalendarDays(this.settings[0].settings.StartDate, 1);
        } else {
            this.maxdate = null;
            this.mindate = null;
        }

        let today = utility.todayDate();
        this.editing = new PolitikerSettings();
        this.editing.StartDate = (this.mindate == null || this.mindate <= today) ? today : this.mindate;
        this.editing.RetirementBenefits.Mode = 0;
        this.editing.VacationBenefits.Mode = 0;

        this.selected = new SettingInfo();
        this.settings.splice(0, 0, this.selected);
    };

    this.canCancel = function () {
        if (this._isSaving) return false;
        if (!this.editing) return false;
        if (!this.form) return false;

        return this.isAdding() || this.form.$dirty;
    };

    this.cancel = function () {
        if (!this.canCancel()) return;

        if (this.isAdding()) {
            this.settings.splice(0, 1);
            this.selected = _.first(this.settings);
        }

        this.onSelectedChanged();
        this.form.$setPristine();
    };

    this.canRemove = function () {
        if (this._isSaving) return false;
        if (!this.editing) return false;
        if (!this.form) return false;
        if (this.isAdding()) return false;

        return true;
    };

    this.remove = function () {
        if (!this.canRemove()) return;

        dialogService.confirm(["Radera perioden permanent.", "Detta kan inte ångras", "Är du säker?"])
            .then(() => {
                this._isSaving = true;
                tromanServer.Politiker.removePeriod(this.editing.Id)
                    .then(() => {
                        stateService.reload();
                    })
                    .catch(dialogService.error)
                    .finally(() => { this._isSaving = false; });
            });
    };

    this.canSave = function () {
        if (this._isSaving) return false;
        if (!this.editing) return false;
        if (!this.form) return false;
        if (!this.form.$valid) return false;

        return this.isAdding() || this.form.$dirty;
    };

    this.save = function save() {

        if (!this.canSave()) return;

        this.form.$commitViewValue();

        if (this.form.$invalid) return;

        this.form.$setSubmitted();

        this._isSaving = true;
        tromanServer.Politiker.setPeriod(this.editing)
            .then(() => {
                stateService.reload();
            })
            .catch(dialogService.error)
            .finally(() => { this._isSaving = false; });
    };

    this.canSaveSystem = function () {
        if (this._isSaving) return false;
        if (!this.systemSettingsForm) return false;
        if (!this.systemSettingsForm.$valid) return false;

        return this.systemSettingsForm.$dirty;
    };

    this.saveSystem = function () {

        if (!this.canSaveSystem()) return;

        this.systemSettingsForm.$commitViewValue();

        if (this.systemSettingsForm.$invalid) return;

        this.systemSettingsForm.$setSubmitted();

        this._isSaving = true;
        tromanServer.System.setSettings(this.systemSettings)
            .then(() => {
                stateService.reload();
            })
            .catch(dialogService.error)
            .finally(() => { this._isSaving = false; });
    };
}]);
